import { useState, memo } from "react";
import { IconButton, Modal, Button } from "../../../../shared/ui";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { VacancyShareSchema, shareForm } from "../../consts";
import { VacancyControlInputText } from "../VacancyControlInput";

import type { IVacancyShareForm } from "../../types";

import styles from "./VacancyShareForm.module.scss";
import { generateMediaQuery } from "../../../../shared/lib/helpers";
import { MediaQueryProperty, MediaSizeEnum } from "../../../../shared/constants/media";
import { useMediaQuery } from "../../../../shared/hooks/useMediaQuery";

export const VacancyShareForm = memo(() => {
    const isMobile = useMediaQuery(generateMediaQuery(MediaQueryProperty.MaxWidth, MediaSizeEnum.sm));

    const [isFill, setIsFill] = useState(false);
    const [isOpen, setIsOpen] = useState(false);

    const {
        control,
        getValues,
        handleSubmit: onSubmit,
    } = useForm<IVacancyShareForm>({
        defaultValues: shareForm,
        resolver: yupResolver(VacancyShareSchema),
    });

    const handleOpen = () => setIsOpen(true);

    const handleClose = () => setIsOpen(false);

    const checkFill = () => setIsFill(Object.values(getValues()).every(Boolean));

    const handleSubmit = (_: IVacancyShareForm) => {
        // отправка ссылки на почту
    };

    return (
        <>
            <IconButton
                icon="share"
                text={!isMobile ? "Поделиться вакансией" : undefined}
                onClick={handleOpen}
                className={styles.share}
            />
            <Modal isOpen={isOpen}>
                <section className={styles.modal}>
                    <IconButton
                        icon="close"
                        theme={isMobile ? "light" : "white"}
                        onClick={handleClose}
                        className={styles.close}
                    />
                    <h2 className={styles.title}>
                        Отправим вакансию
                        <br />
                        вашему знакомому
                    </h2>
                    <form className={styles.form} onSubmit={onSubmit(handleSubmit)}>
                        <VacancyControlInputText
                            name="email"
                            control={control}
                            placeholder="Email"
                            onChangeFill={checkFill}
                        />
                        <Button as="button" type="submit" isDisabled={!isFill} size="s" className={styles.button}>
                            Поделиться
                        </Button>
                    </form>
                </section>
            </Modal>
        </>
    );
});

VacancyShareForm.displayName = "VacancyShareForm";
